var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_2059",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.4762,
    height: 54.4762,
    fill: "url(#pattern0_37_2059)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_2059)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.4762,
    height: 54.4762,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_37_2059",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_37_2059",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_37_2059",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACoUlEQVR4nO2dPY9NURSGH81Fo1H6CJ1khij8BILEDyDRUOIfOL+AmMyIj25UolHQoxOFqIaCEKEQlYQZicRlyZUt0Qxn7zl7rzVz3yd525v9rudk59xT7A1CCCGEEEIIIYQQQvRnP7AAPAdWANvgWUld54FZz8FvBm4APwIMxZwy6X4dGHkM/1GAAViQPGwt4WaA0hYs11ru+dO87dgqGQMzLQQsBChrQTPXQsCLAEUtaJZaCFgOUNSC5ksLAd4lLXgkAAlYV1vGW+A98CnlqwRQJR+BReA0sDv9mVyNrcBO4CBwVgJYUyZP94U01BIm7/YSQFnuAdvW2FcCKMtFYNMAfSWA/NwasK8EkJenA3+ZlADycnjgvhJA/zyp0FcC6J8zFfpKAP2zp0JfCaBfXhV0OZDemF6nzxJDrKM6FjT3M3scAb5VWEd1LGgWM3u8rLSO6ljQXMrosKPiOqpjQdNldDgkAb4CjkqAr4BjEiABxXgP2iQgZrqMDhIgAeV4D9okoH1Ope/8/8rejA7be/zen9yRANiFH7clAFcBjyUAVwEfJAA3AVuAnxKAm4B9BWutzjQJOC4BuAo4JwG4CrgsAbgKuCsBuAp4JgH8zjvgzX9yPqPDiR6/N8l3CaDKx7iTFddRHe9BmwTETJfRQQIkoBzvQZsExEyX0UECJKAc70GbBMRMl9FBAiSgHO9BmwTETJfRQQIkoBzvQZsExEyX0UECJKAc70GbBMRMl9FBAiRg4x3c2gUQ8JkpPrq4CyCgydHF8wGGbUEFXKEBs+modu+BWzABzY6vJ13b4T1wCybgKg0ZpWs7vIduQQQ88LhHZpSu7RhPsYBxevKbD/9vZtLNEUvOr6hdIwHLqetcyz1fCCGEEEIIIYQQQrDu+QVECyqwQZh58AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c97104ef4bcefab349d5202cefcde748.svg";
export { ForwardRef as ReactComponent };